import Script from 'next/script';

export default function HubSpotTracking() {
  const hubspotId = process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID || '26847356';

  if (!hubspotId) return null;

  return (
    <Script
      type="text/javascript"
      id="hs-script-loader"
      src={`https://js-eu1.hs-scripts.com/${hubspotId}.js`}
      strategy="afterInteractive"
      async
      defer
    />
  );
}
